import { Component, AfterViewInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DxDataGridComponent } from 'devextreme-angular';
import { DataService } from '../core/data.service';
import { ActiveModal } from '../shared/modal/modal.service';


@Component({
  selector: 'app-recurrent-orderitem-form',
  templateUrl: 'recurrent-orderitem-form.component.html',
  styleUrls: ['recurrent-orderitem-form.component.css']
})
export class RecurrentOrderItemFormComponent implements AfterViewInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  products = [];
  @Output() addedItem = new EventEmitter();
  quantity;
  price;
  selectedProduct;
  constructor(
    private notificationsService: NotificationsService,
    private dataService: DataService,
    private activeModal: ActiveModal
  ) { }

  ngAfterViewInit() {
    this.dataGrid.instance.option({
      filterRow: { visible: true },
      hoverStateEnabled: true,
      onSelectionChanged: this.onGridSelectionChanged.bind(this),
      selection: { mode: 'single' },
      showBorders: false
    });

    this.dataService.getProducts().then(products => {
      this.products = products;
    });
  }
  onGridSelectionChanged(e) {
    this.selectedProduct = e.selectedRowsData[0];
  }
  addPrduct() {
    if (this.selectedProduct == null ) {
      this.notificationsService.error('Missing Value', 'Select the Product.');
      return;
    }
    this.addedItem.emit({
      productID: this.selectedProduct.id,
      product: this.selectedProduct,
      productName: this.selectedProduct.name,
      qty: this.quantity,
      price: this.price,
      deleted: false,
      perQty: 1,
      qtyUnit: null,
      saleLineNumber: null,
      surchargeLimit1: null,
      surchargeLimit2: null,
      surchargeLimit3: null,
      surchargeValue1: null,
      surchargeValue2: null,
      taxID: null,
      unitDiff: 1,
      abgabeTyp: null,
      discount: null,
      extNr1: null,
      extNr2: null,
      id: 0,
      orderItemNumber: null,
      orderTemplateID: 0

    });
    this.activeModal.dismiss();
  }
  cancel() {
    this.activeModal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/recurrence/recurrent-orderitem-form.component.ts